import view from './view'

export default view


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/common/editor/index.js